export const convertToRol = unit => unit;
// if (!unit) {
//   return "ROL";
// }
// return "ROL";

export const convertToRolExport = unit => {
  if (unit === "EA") {
    return unit;
  }
  if (!unit) {
    return "ROL";
  }
  return "ROL";
};

export const isKO1KO9 = productGroup => {
  if (productGroup === "K01" || productGroup === "K09") {
    return true;
  }
  return false;
};
